import React, {useContext} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import Stack from '@mui/material/Stack';
import {isMobile, matchesAnyRegex,} from "../App/utils.js";
import Dropzone from '../Chat/Dropzone.js';
import {AlertContext} from "../App/App.js";
import {docToTextAPI} from "../API/docToTextAPI.js";
import {inputTools} from "./constant.js";


const types = [
    "text/html",
    "application/atom+xml",
    "application/rss+xml",
    "text/markdown",
    "application/epub+zip",
    "application/xml",
    "application/xsl+xml",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.text-template",
    "application/rtf",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    "application/vnd.ms-excel.sheet.macroenabled.12",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "text/csv",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.oasis.opendocument.spreadsheet-template",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.presentationml.template",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.presentation-template",
    "application/vnd.oasis.opendocument.graphics",
    "application/vnd.oasis.opendocument.graphics-template",
    "application/javascript",
    "text/*",
    /^text\/.+$/
];

export const DocToText = ({ style, setBlockingLoading, onSuccess, KB}) => {
    const {setSystemAlert} = useContext(AlertContext);
    const onFileUpload = async event => {
        const selectedFile = event instanceof File ? event : event.target.files[0];

        if (!selectedFile?.type) return;
        if (!matchesAnyRegex(selectedFile.type, types)) {
            setSystemAlert({msg: 'Invalid file type', type: 'error', duration: 3000})
            return;
        }

        try {
            setBlockingLoading(true)
            const response = await docToTextAPI(selectedFile, setSystemAlert, KB);

            if (response?.text) onSuccess(response.text)
            setBlockingLoading(false)
        } catch (e) {
            setBlockingLoading(false)
            setSystemAlert({msg: 'Error during upload', type: 'error', duration: 3000})
            console.error(e);
        }

        if(event?.target?.value) event.target.value = null;
    }

    let acceptTypes = types.filter(o => typeof o === "string").join(',');

    return (
        <Stack alignItems="center" spacing={2} style={style} >
            <Dropzone onFileUpload={onFileUpload} types={types} id={"imageToText"} />

            <Tooltip title={inputTools.docToText.label}>
                <IconButton color="primary" aria-label={inputTools.docToText.label} component="label">
                    <input hidden accept={acceptTypes} type="file" onChange={onFileUpload} />
                    {isMobile ? inputTools.docToText.iconMobile() : inputTools.docToText.icon()}
                </IconButton>
            </Tooltip>
        </Stack>
    );
}